import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import Screens from '..';
import buyClickedHandler from '../Shop/buyClickedHandler';
import QueryParamsProxy from '../../utils/queryParamProxy';
import routeParamConstants, { ShopTypes } from '../../utils/routeParamConstants';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import audio from '../../utils/audio';
import Utils from '../../utils';
import ENVIRONMENT_VARIABLES from '../../utils/environmentVariables';
import { getText, TEXT_KEY } from '../../utils/localization';
import { purchaseActionTriggers } from '../../constants/userActions';
import { PLATFORM } from '../../constants';
var formatter = require('format-number');
var format = formatter({
  prefix: '',
  suffix: '',
  truncate: 0
});
var OutOfCoin = /*#__PURE__*/function (_Component) {
  function OutOfCoin() {
    var _this;
    _classCallCheck(this, OutOfCoin);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, OutOfCoin, [].concat(args));
    _this.quickBuyOfferDetails = {};
    _this._quickBuyHandler = function (sku, name) {
      audio.onClick();
      var _this$props = _this.props,
        outOfCoinsOffer = _this$props.outOfCoinsOffer,
        assignTransationUUID = _this$props.assignTransationUUID,
        gameInfo = _this$props.gameInfo;
      sku = _this._getSKUBasedOnPlatform(outOfCoinsOffer);
      name = outOfCoinsOffer.NAME;
      _this.props.isOutOfCoinsPurchase(true);
      _this.props.dismissModal();
      _this.buyServerHandler = buyClickedHandler.bind(_this);
      _this.buyServerHandler(sku, name, '');
      var platform = Utils.getPlatform();
      var store;
      switch (platform) {
        case PLATFORM.WEB:
          store = 'cams';
          break;
        case PLATFORM.MOBILE_WEB:
          store = 'cams';
          break;
        case PLATFORM.IOS:
          store = 'appstore';
          break;
        default:
          store = platform;
      }
      var id = Logger.generateUUID();
      assignTransationUUID(id);
      Logger.setActionTrigger(purchaseActionTriggers.OUT_OF_COINS_BUY_BUTTON);
      var eventPayload = {
        type: 'regular',
        product_id: sku.toString(),
        currency: 'usd',
        store: store,
        balance_before: _this.props.coin.toString(),
        is_test: ENVIRONMENT_VARIABLES.ENVIRONMENT !== 'PROD' ? 1 : 0,
        amount: _this.props.outOfCoinsOffer.PRICE,
        id: id,
        trigger: purchaseActionTriggers.OUT_OF_COINS_BUY_BUTTON,
        game_provider: gameInfo.gameProvider,
        game_id: gameInfo.gameId
      };
      Logger.sendEvent(EVENT_TYPES.TRANSACTION_INITIATED, eventPayload);
    };
    _this._visitStoreHandler = function () {
      audio.onClick();
      _this.props.dismissModal();
      QueryParamsProxy.setQueryParams(_defineProperty(_defineProperty({}, routeParamConstants.PARAM_MODAL, Screens.Shop), routeParamConstants.PARAM_SHOP_TYPE, ShopTypes.COINS));
    };
    return _this;
  }
  _inherits(OutOfCoin, _Component);
  return _createClass(OutOfCoin, [{
    key: "_getSKUBasedOnPlatform",
    value: function _getSKUBasedOnPlatform(outOfCoinsOffer) {
      if (Utils.getPlatform() === PLATFORM.IOS) return outOfCoinsOffer.MOBILE_PRODUCT_IAP_ID_IOS;
      if (Utils.getPlatform() === PLATFORM.ANDROID) return outOfCoinsOffer.MOBILE_PRODUCT_IAP_ID_ANDROID;
      return outOfCoinsOffer.CURRENCY_ITEM_ID;
    }
  }, {
    key: "render",
    value: function render() {
      var outOfCoinsOffer = this.props.outOfCoinsOffer;
      var quickBuyOfferDetails = {
        title: getText(TEXT_KEY.QUICK_BUY),
        coinAmount: format(outOfCoinsOffer.AMOUNT),
        plusIcon: '+',
        loyaltyAmount: format(outOfCoinsOffer.BONUS_LOYALTY_AMOUNT),
        totalAmount: "".concat(getText(TEXT_KEY.CURRENCY_SIGN)).concat(outOfCoinsOffer.PRICE)
      };
      return this.props.render({
        quickBuyOfferDetails: quickBuyOfferDetails,
        quickBuyHandler: this._quickBuyHandler,
        visitStoreHandler: this._visitStoreHandler
      });
    }
  }]);
}(Component);
export { OutOfCoin as default };